import { render, staticRenderFns } from "./quick_bi.vue?vue&type=template&id=edc7c9a2&scoped=true&"
import script from "./quick_bi.vue?vue&type=script&lang=js&"
export * from "./quick_bi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc7c9a2",
  null
  
)

export default component.exports